import React from 'react';
import UserLocationList from '../../components/userlocationcomponents/UserLocationList';

function UserLocationDetails({ renderPageContent }) {

    return (
        <>
            {/* Dynamic content goes here */}
            <UserLocationList renderPageContent={renderPageContent} />
        </>
    );

}

export default UserLocationDetails;
